// Local expiry display only. Server policy/risk checks remain authoritative.
export function pilotView(data, now) {
  if (!data) return null;
  const day = new Date(now).toISOString().slice(0, 10);
  let reservationMicros = 0, entries = 0, known = true;
  const runs = data.runs.map(run => {
    const age = now - new Date(run.created_at).getTime();
    return { ...run, expired: !Number.isFinite(age) || age < 0 || age > 300000, proposals: run.proposals.map(proposal => {
      const plan = proposal.plan;
      if (!plan) return proposal;
      const terminal = ['cancelled', 'invalidated'].includes(proposal.review_state) ? proposal.review_state
        : ['cancelled', 'invalidated'].includes(plan.status) ? plan.status : null;
      const expired = !Number.isFinite(plan.expires_at) || plan.expires_at * 1000 <= now;
      const viewState = terminal || (expired ? 'expired' : 'reserved_for_review');
      if (!Number.isSafeInteger(plan.reserved_micros) || typeof plan.day !== 'string') known = false;
      if (viewState === 'reserved_for_review' && plan.day === day) { reservationMicros += plan.reserved_micros; entries++; }
      return { ...proposal, plan: { ...plan, view_state: viewState } };
    }) };
  });
  const result = { ...data, runs };
  if (data.wallet_verification_expires_at !== undefined && data.wallet_verification_expires_at !== null) {
    result.wallet_verified = data.wallet_verified && data.wallet_verification_expires_at * 1000 > now;
  }
  const oldReserved = Math.round(Number(data.reserved_usd) * 1000000), remaining = Math.round(Number(data.remaining_usd) * 1000000);
  if (known && Number.isSafeInteger(reservationMicros) && Number.isSafeInteger(oldReserved) && Number.isSafeInteger(remaining)) {
    result.reserved_usd = String(reservationMicros / 1000000);
    result.entries_reserved = entries;
    result.remaining_usd = String(Math.max(0, remaining + oldReserved - reservationMicros) / 1000000);
  }
  return result;
}